<template>
    <svg viewBox="0 0 19 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19 9.35998C19 14.5293 10.0035 29 9.49999 29C8.99651 29 0 14.5293 0 9.35998C0 4.1906 4.25329 0 9.49999 0C14.7467 0 19 4.1906 19 9.35998ZM9.5 12.8604C11.433 12.8604 13 11.2933 13 9.36035C13 7.42735 11.433 5.86035 9.5 5.86035C7.567 5.86035 6 7.42735 6 9.36035C6 11.2933 7.567 12.8604 9.5 12.8604Z" />
    </svg>
</template>
